import "./index.scss";
import ImageIcon from "components/ImageIcon";
import React from "react";

interface Props {
  abstract: string;
  iconName: string;
  title: string;
}

const Message = ({ title, abstract, iconName }: Props) => {
  return (
    <div className="message-search">
      <div className="message-search__content">
        {iconName && (
          <div className="message-search__icon">
            <ImageIcon
              iconType="svgDesign"
              svgLibrary={iconName}
              svgColor="neutralSecondary"
              svgBackground="neutralTertiary"
            />
          </div>
        )}
        <div className="message-search__title">{title}</div>
        <div className="message-search__abstract">{abstract}</div>
      </div>
    </div>
  );
};

export default Message;
